<route>
{
  "meta": {
    "permission": [
      "base_config.view_soldby"
    ]
  }
}
</route>

<template>
  <v-container fluid>
    <dial-sold v-model="dialog" :to-edit="toEdit" @done="reload = true" />
    <i-table
      app="base_config.soldby"
      api="sold"
      :headers="headers"
      :reload.sync="reload"
      :title="$tc('measure', 1)"
      @click:create="open()"
      @click:edit="open($event)"
    >
      <template v-slot:deleteBtn="{ item, remove }">
        <i-btn
          :title="$tc('delete', 1)"
          outlined
          classes="mx-1"
          icon="fa-trash"
          color="error"
          @click="remove(item.pk)"
        />
      </template>
    </i-table>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import DialSold from '@/components/sold/modal.vue'
export default {
  components: {
    DialSold
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t('name'),
          value: 'name'
        },
        {
          text: this.$t('abbr'),
          value: 'abbr'
        },
        {
          text:
            this.checkPermissions.delete || this.checkPermissions.edit
              ? this.$t('action')
              : '',
          value:
            this.checkPermissions.delete || this.checkPermissions.edit
              ? 'actions'
              : '',
          align: 'center',
          width: '160px'
        }
      ]
    },
    ...mapGetters({
      getPermissions: 'session/getPermissions',
      isAdmin: 'session/isAdmin'
    }),
    /**
     * Determina si el usuario tiene los permisos necesarios según la indicación
     *
     * @return {boolean}
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    checkPermissions() {
      return {
        delete: this.getPermissions([`base_config.delete_soldby`]),
        edit: this.getPermissions([`base_config.change_soldby`])
      }
    }
  },
  data() {
    return {
      reload: false,
      dialog: false,
      toEdit: null
    }
  },
  methods: {
    open(item) {
      this.toEdit = item === undefined ? null : item
      this.dialog = true
    }
  }
}
</script>
